import './app/publicPath'

const Vue = window.Vue

Vue.component('MyPointsOverview', () => import('./app/components/myPoints/MyPointsOverview.vue'))
Vue.component('MaxPointsItemNote', () => import('./app/components/maxPointsNote/MaxPointsItemNote.vue'))
Vue.component('MaxPointsBasketNote', () => import('./app/components/maxPointsNote/MaxPointsBasketNote.vue'))
Vue.component('CouponCampaignList', () => import('./app/components/campaign/CouponCampaignList.vue'))
Vue.component('ConvertToCustomerRegistration', () => import('./app/components/customer/ConvertToCustomerRegistration.vue'))

import './app/main'
